import { useEffect } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { AuthProvider, useAuth } from './auth/AuthContext'
import { Layout } from './components/Layout'
import { Home } from './pages/Home'
import { Profile } from './pages/Profile'
import { Leaderboard } from './pages/Leaderboard'
import { Record } from './pages/Record'
import { Tasks } from './pages/Tasks'

function Gate({ children }: { children: React.ReactNode }) {
  const { status, error, retry } = useAuth()
  const { t, i18n } = useTranslation()
  useEffect(() => {
    document.title = t('app.title')
  }, [t, i18n.language])

  if (status === 'loading') {
    return (
      <div className="center-screen" role="status" aria-live="polite">
        <div className="spinner" aria-hidden />
        <p>{t('auth.signingIn')}</p>
      </div>
    )
  }

  if (status === 'error') {
    return (
      <div className="center-screen" role="alert">
        <p className="error">{error ?? t('auth.failed')}</p>
        <button type="button" className="btn" onClick={retry}>
          {t('app.retry')}
        </button>
      </div>
    )
  }

  return <>{children}</>
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Gate>
          <Routes>
            <Route element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="record" element={<Record />} />
              <Route path="tasks" element={<Tasks />} />
              <Route path="events" element={<Navigate to="/leaderboard" replace />} />
              <Route path="profile" element={<Profile />} />
              <Route path="leaderboard" element={<Leaderboard />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </Gate>
      </BrowserRouter>
    </AuthProvider>
  )
}
